import { Box, Link } from '@mui/material'

const Header = () => {
  const styles = {
    header: {
      display: 'grid',
      gridTemplateRows: '20% 80%',
      width: '100%',
      height: '60vh',
      maxHeight: '600px'
    },
    imageContainer: {
      position: 'relative',
      width: '100%',
      height: '100%'
    },
    logo: {
      position: 'relative',
      width: { xs: '50vmin', sm: '25vmin' },
      height: 'auto',
      top: '20%',
      left: '10%',
      zIndex: 2
    },
    image: {
      width: '100%',
      height: '80%',
      objectFit: 'cover'
    },
    text: {
      position: 'absolute',
      top: '20%',
      left: '10%',
      color: 'white',
      fontSize: { xs: '24px', sm: '36px' },
      fontWeight: 'bold',
      zIndex: 3
    }
  }

  return (
    <Box component='header' sx={styles.header}>
      <Link href='https://birthcare.co.nz/' sx={{ mb: 4 }}>
        <Box component='img' src='/assets/Birthcare.png' alt='Logo' sx={styles.logo} />
      </Link>
      <Box sx={styles.imageContainer}>
        <Box component='img' src='/assets/BirthcareImage.png' alt='Picture' sx={styles.image} />
        <Box component='h1' sx={styles.text}>Birthcare Patient Registration</Box>
      </Box>
    </Box>
  )
}

export default Header
